<template>
  <b-container>
    <b-row class="kontakt overflow-hidden" id="mapka">
      <b-col>
        <h3>Kontakt</h3>
        <!-- <iframe class="animated fadeIn"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2550.099010509025!2d19.12223031572494!3d50.271409879450935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4716daafd93eae8b%3A0x578d7ef5dc6e48c8!2sTeatralna+11%2C+41-200+Sosnowiec!5e0!3m2!1spl!2spl!4v1564571377461!5m2!1spl!2spl"
          frameborder="0"
          style="border:0"
          allowfullscreen
        ></iframe> -->

        <GmapMap
          :center="center"
          :zoom="17"
          map-type-id="roadmap"          
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center=m.position"
          />
        </GmapMap>


        <div class="kontakt-list">
          <span class="icon map">
            <font-awesome-icon icon="map-marker-alt" style="font-size:25px" />
          </span>
          <span>ul. Sosnowiecka 1, <span class="text-nowrap"> 40-337 Katowice</span></span>
        </div>
        <br />
        <!-- tel. +48 601-403-460 <br>
email: nacinarki@gmail.com<br>
<br>
nr konta: 26 1050 1360 1000 0008 0013 3985 -->
        <!-- <div class="kontakt-list">
          <span class="icon user">
            <font-awesome-icon icon="user-tie" />
          </span>
          <span>Jerzy Kuboń</span>
        </div> -->
        <div class="kontakt-list">
          <span class="icon phone">
            <font-awesome-icon icon="mobile-alt" />
          </span>
          <span>601 403 460</span>
        </div>
        <div class="kontakt-list">
          <span class="icon email">
            <font-awesome-icon icon="at" />
          </span>
          <span>wyślij wiadomość przez formularz na dole strony</span>
        </div>
        <!-- <br />
        <div class="kontakt-list">
          <span class="icon bank">
            <font-awesome-icon icon="piggy-bank" style="position:relative; top:-3px;"/>
          </span>
          <span>26 1050 1360 1000 0008 0013 3985</span>
        </div> -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'KontaktComponent',
  components: {},
  methods: {},
  data() {
    return {
      center: { lat: 50.270176, lng: 19.111978 },
      markers: [
        {
          position: { lat: 50.270176, lng: 19.111978 }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';
.kontakt-list {
  display: flex;
  align-items: center;
  .icon {
    flex: 0 0 30px;
    text-align: center;
    font-size: 21px;
    margin-right:10px;
    line-height: 19px;
    &.map{
      color: rgb(194, 59, 59);
    }
    &.bank{
      color:#4c4c4c;
    }
    &.user{
      color: #4c4c4c;
    }
    &.phone{
      color: #4c4c4c;
    }
    &.email{
      color: #4c4c4c;
    }
  }
}
h3 {
  font-size: 60px;
  font-weight: bold;
  text-align: left;
  color: #777;
  margin-bottom: 20px;
  margin-top: 15px;
  text-transform: uppercase;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size: 36px;
  }
}
iframe, .vue-map-container {
  width: 100% !important;
  height: 420px !important;
  margin: 25px 0;
}
.kontakt {
  font-size: 22px;
  font-weight: bold;
  line-height: 24px;
  color: gray;
}
</style>